/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

/**
 * active when the user would receive notifications on at least one channel under current rules
 */
export type NotificationSubscriptionStatus = (typeof NotificationSubscriptionStatus)[keyof typeof NotificationSubscriptionStatus];

export const NotificationSubscriptionStatus = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
} as const;
